import React from "react";
import TimeAgo from "react-timeago";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";
import { cleanDate } from "../../../../util/app";

const TimetableList = ({ items, onView }) => {
    if (items && items.length < 1)
        return (
            <div className="text-center text-pink">
                <i className="material-icons" style={{ fontSize: "4em" }}>
                    info
                </i>
                <br />
                <strong>No Timetable has been added yet</strong>
            </div>
        );
    return (
        <table className="table table-bordered">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Start Date & Time</th>
                    <th>End Date & Time</th>
                    <th className="text-center">Plans</th>
                    <th className>
                        <span>Staff</span>
                    </th>
                    <th className="text-center">View</th>
                </tr>
            </thead>
            <tbody>
                {items &&
                    items.map((item, index) => (
                        <tr key={index}>
                            <td className="inbox-small-cells">
                                <div className="todo-check pull-left">{index + 1}</div>
                            </td>
                            <td className="view-message">
                                {cleanDate(item.start)}
                                <br />
                                <small className="text-muted">
                                    <TimeAgo date={item.created_at}></TimeAgo>
                                </small>
                            </td>

                            <td className="view-message">
                                {cleanDate(item.end)}
                                <br />
                                <small className="text-muted">
                                    Created: <span className="text-pink">{cleanDate(item.created_at, true)}</span>
                                </small>
                            </td>
                            <td className="view-message text-center">
                                <strong>{item.plans.length}</strong>
                            </td>
                            <td className="view-message">
                                <StaffProfileCard item={item.author} />
                            </td>
                            <td className="view-message text-center">
                                <button onClick={() => onView(item)} title="View" className="mdl-button mdl-button--icon mdl-button--colored">
                                    <i className="material-icons text-primary">arrow_right_alt</i>
                                </button>
                            </td>
                        </tr>
                    ))}
            </tbody>
        </table>
    );
};

export default TimetableList;
